/**
 * Load Script
 *
 * Load script for the theme.
 *
 * @package		McMorgan & Company
 * @subpackage	Theme Scripts
 *
 * @since	1.0.0
 */

/*! McMorgan & Company Load Script * Copyright (c) 2026 Robert Noakes * License: GNU General Public License v2 or later */

if (window.mmc_l10n)
{
	var mmc_link = document.createElement('link');

	mmc_link.setAttribute('rel', 'stylesheet');
	mmc_link.setAttribute('type', 'text/css');
	
	document.head.appendChild(mmc_link);
	
	mmc_link.setAttribute('href', window.mmc_l10n.assets.css);

	var mmc_script = document.createElement('script');

	document.head.appendChild(mmc_script);
	
	mmc_script.setAttribute('src', window.mmc_l10n.assets.js);
}